"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'ordersByMonth',
      queryDate: '',
      listLoading: '',
      list: [],
      sourceApi: null
    };
  },
  created: function created() {
    this.setCurrentMonth();
  },
  mounted: function mounted() {
    this.fetchListData();
  },
  methods: {
    setCurrentMonth: function setCurrentMonth() {
      // 默认当月
      var nowDate = new Date();
      var month = nowDate.getMonth() + 1;
      var currentMonth = nowDate.getFullYear() + '' + (month >= 10 ? month : '0' + month);
      this.queryDate = currentMonth.toString();
    },
    fetchListData: function fetchListData() {
      var _this = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        month: this.queryDate
      };
      this.listLoading = true;
      this.$api.reportModule.getOrderListByMonth(param, this.sourceApi.token).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data || [];
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this.listLoading = false;
      });
    },
    toOrderDetails: function toOrderDetails() {
      this.$router.push({
        path: '/reportModule/ordersByMonth/storeDetailList',
        query: {
          month: this.queryDate
        }
      });
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};